import * as React from 'react';

function SvgIconListView(props) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M9.62 10.694l.005-.22c.28-.247.542-.508.782-.781l.218-.008 4.316 4.249a.712.712 0 11-1.007 1.008L9.62 10.694zm-3.245 1.205a5.525 5.525 0 110-11.05 5.525 5.525 0 010 11.05zm.003-9.746a4.225 4.225 0 100 8.45 4.225 4.225 0 000-8.45z" />
    </svg>
  );
}

export default SvgIconListView;
